export default "__VITE_ASSET__BnW3n73w__"